import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-linkedin-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-linkedin-svg-icon.component.html',
  styleUrl: './ln-linkedin-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnLinkedinSvgIconComponent {
  @Input() class = 'w-8 h-8';
}
